import type { TemplateProcess, Graph } from "@lr-notitia/notitia-operator/schemas";
import { Ref, computed } from "vue";
import { useSymbolsStore } from "../symbols";

let symbolsStore: ReturnType<typeof useSymbolsStore>;
function init() {
	symbolsStore = useSymbolsStore();
}

export const templateProcesses = (graph: Ref<Graph>) =>
	computed<TemplateProcess[]>(() => {
		if (!symbolsStore) init();
		return (
			Object.values(graph.value.nodes).filter(
				(node) => node.type === "process" && node.layer === "template"
			) as TemplateProcess[]
		).sort((a, b) =>
			symbolsStore
				.term({ id: a.refersTo, terminology: a.terminology })
				.toLocaleLowerCase()
				.localeCompare(symbolsStore.term({ id: b.refersTo, terminology: b.terminology }).toLocaleLowerCase())
		);
	});

export function templateProcess(domainId: Ref<string>, graph: Ref<Graph>) {
	return {
		byId: (id: string) => byId(id, graph),
	};
}

function byId(id: string, graph: Ref<Graph>): TemplateProcess | undefined {
	let hit = graph.value.nodes[id];
	return hit && hit.layer === "template" && hit.type === "process" ? (hit as TemplateProcess) : undefined;
}
